import * as React from 'react';
import styled from 'styled-components';

const CoverImageContainerWrapper = styled.div`
  /* padding-top: 24px; */
`;

const CoverImageWrapper = styled.div`
  background: ${props => props.theme.colorBorder};
  max-height: 400px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-radius: ${props => props.theme.borderRadius}px
    ${props => props.theme.borderRadius}px 0 0; */

  margin-inline-start: 0;
  margin-inline-end: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export interface ICoverImageContainerProps {
  children?: React.ReactNode;
}

export function CoverImageContainer(props: ICoverImageContainerProps) {
  const { children } = props;

  return (
    <CoverImageContainerWrapper>
      <CoverImageWrapper>{children}</CoverImageWrapper>
    </CoverImageContainerWrapper>
  );
}
